import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

const flexColumn = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

export const TransparencySectionContainer = styled.section(({ theme }) => ({
  background: `${theme.color.neutral["07"]} !important`,
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const TransparencySectionContent = styled.div(() => ({
  ...flexColumn,
  gap: "12px",
}));

export const TransparencySectionHeader = styled.header(() => ({
  ...flexColumn,
  gap: "12px",
}));

export const TransparencySectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const TransparencySectionDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));

export const TransparencyItemContainer = styled.div(({ theme }) => ({
  display: "flex",
  gap: "60px",

  ".transparencyImage": {
    display: "none",

    [theme.breakpoint.lg()]: {
      display: "inherit",
    },
  },
}));

export const TransparencyItemList = styled.div(({ theme }) => ({
  ...flexColumn,

  span: {
    width: "fit-content",
    ...DefaultParagraphLargeFactory({ theme }),
  },
}));
